import React from "react";

// Function to format date as "DD.MM.YYYY"
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0"); // Ensures two digits for day
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensures two digits for month (months are 0-based)
  const year = date.getFullYear();
  return `${day}.${month}.${year}`; // Returns date in the format: "03.01.2025"
};

const PrepnexaNews = ({ posts }) => {
  return (
    <div className="container mx-auto px-4 py-10">
      <div className="text-2xl font-semibold text-gray-900 mb-8 mx-10">
        <h4>Prepnexa News</h4>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mx-10">
        {posts.map((post, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-lg overflow-hidden transition-all transform hover:scale-105 hover:shadow-2xl hover:bg-gray-50"
          >
            <a href={post.link} title={post.title}>
              <img
                className="w-full h-auto object-cover"
                src={
                  post.featuredImage
                    ? `${process.env.REACT_APP_DO_SPACES_URL}${post.featuredImage}`
                    : "/placeholder.jpg" // Fallback image
                }
                alt={post.title}
              />
            </a>
            <div className="p-4">
              <div className="flex items-center text-sm text-gray-600">
                <span className="mr-2">{post?.author || "Unknown Author"}</span>{" "}
                {/* Author */}
                <span>-</span>
                <span className="ml-2">
                  {formatDate(post?.date) || "No date available"}
                </span>{" "}
                {/* Formatted date */}
              </div>
              <div className="text-sm text-gray-500 mb-2">
                {post?.readMins || "N/A"} {/* Read time */}mins read
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                <a
                  href={post.link}
                  title={post.title}
                  className="hover:text-blue-500"
                >
                  {post.title}
                </a>
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrepnexaNews;
